import { useConnection } from 'hooks/useConnection'
import { useCallback, useMemo } from 'react'
import { useSignMessage } from 'wagmi'

import rawMessageTemplate from './message.txt?raw'

export enum SignMessageStatus {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  SIGNED = 'SIGNED',
  ERROR = 'ERROR',
}

const TERMS_LINK = 'https://documentation.kodiak.finance/informational/claim-terms' // The full URL for auto-linking

export function useSignClaimMessage() {
  const { account } = useConnection()
  const { signMessageAsync, isPending, isError, error, isSuccess } = useSignMessage()

  // Inject the address and link into the template
  const formattedMessage = useMemo(() => {
    if (!account) return ''
    return rawMessageTemplate.replace('<ADDRESS>', account).replace('<LINK>', TERMS_LINK)
  }, [account])

  const handleSign = useCallback(async () => {
    if (!account || !formattedMessage) return

    try {
      await signMessageAsync({
        message: formattedMessage,
      })
    } catch (error) {
      console.error('Failed to sign message:', error)
    }
  }, [account, formattedMessage, signMessageAsync])

  const status: SignMessageStatus = useMemo(() => {
    if (isPending) return SignMessageStatus.PENDING
    if (isError) return SignMessageStatus.ERROR
    if (isSuccess) return SignMessageStatus.SIGNED
    return SignMessageStatus.IDLE
  }, [isPending, isError, isSuccess])

  return [status, handleSign, formattedMessage, TERMS_LINK] as const
}
